var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-row', {
    attrs: {
      "id": "home"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "interactions/live"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _c('br'), _vm._v("Live")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "interactions/historical"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-book-open"
  }), _c('br'), _vm._v("Historical")])])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5378dbb6","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/InteractionMenu.vue
// module id = 907
// module chunks = 1